import { atom, useAtomValue, useSetAtom } from 'jotai';
import chatttSDK from 'services/chattt';

const browserSettingsAtom = atom<Chattt.BrowserSettings>(chatttSDK?.app?.getBrowserSettings?.());
const browserSettingsState = atom(
  (get) => get(browserSettingsAtom),
  (_, set, next: Chattt.BrowserSettings) => {
    set(browserSettingsAtom, next);
    chatttSDK?.app?.setBrowserSettings?.(next);
  },
);

export const useBrowserSettings = () => useAtomValue(browserSettingsState);
export const useSetBrowserSettings = () => useSetAtom(browserSettingsState);
